import * as React from "react"
import { graphql } from "gatsby"
import HeroSection from "../components/Global/HeroSection"
import InfoBlock from "../components/Global/InfoBlock"
import DualInfoBlock from "../components/Global/DualInfoBlock"
import myphoto from "../images/Me.jpg"
import Layout from "../components/layout"
import Seo from "../components/seo"

import "../components/bootstrap.min.css"
import "../components/layout.css"
// import { Link } from "gatsby"
// import Contact from "../components/Contact/Contact"
// import aboutphoto from "../images/about.png"

const IndexPage = ({ data }) => (
  <Layout>
    <Seo title="Home" />
    <HeroSection
      img={data.img.childImageSharp.fluid}
      title="my first react project"
      subtitle=""
      heroclass="hero-background"
      page="/index"
    />
    <InfoBlock heading="about us" photo={data.photo.childImageSharp.fluid} />
    <DualInfoBlock
      heading="our team"
      photo={myphoto}
      img2={data.img2.childImageSharp.fluid}
    />
  </Layout>
)
export const query = graphql`
  {
    img: file(relativePath: { eq: "heromain.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    photo: file(relativePath: { eq: "about.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    img2: file(relativePath: { eq: "about.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
export default IndexPage
